export default "__VITE_ASSET__C8LfND4q__"